import { colors } from '@narvar/hum-constants';
import { css } from 'emotion';

const s = css`
  display: flex;
  flex-direction: column;
  `;

export default s;
